import {
  provideHttpClient,
  withInterceptorsFromDi,
  HTTP_INTERCEPTORS,
} from "@angular/common/http";
import {
  ApplicationConfig,
  ErrorHandler,
  importProvidersFrom,
  provideZoneChangeDetection,
} from "@angular/core";
import { provideAnimationsAsync } from "@angular/platform-browser/animations/async";
import {
  provideRouter,
  withComponentInputBinding,
  withInMemoryScrolling,
} from "@angular/router";
import { TablerIconsModule } from "angular-tabler-icons";
//Import all material modules
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import * as TablerIcons from "angular-tabler-icons/icons";
import { provideToastr } from "ngx-toastr";
import { APP_ROUTES } from "./app.routes";
import { ErrorInterceptor } from "./core/interceptors/error.interceptor";
import { LoadingInterceptor } from "./core/interceptors/loading.interceptor";
import { ErrorHandlerService } from "./core/services/error-handler.service";

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: ErrorHandler, useClass: ErrorHandlerService },
    provideZoneChangeDetection({ eventCoalescing: true, runCoalescing: true }),
    provideRouter(
      APP_ROUTES,
      withInMemoryScrolling({
        scrollPositionRestoration: "enabled",
        anchorScrolling: "enabled",
      }),
      withComponentInputBinding()
    ),
    provideAnimationsAsync(),
    provideHttpClient(withInterceptorsFromDi()),
    { provide: HTTP_INTERCEPTORS, useClass: LoadingInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    importProvidersFrom(
      FormsModule,
      ReactiveFormsModule,
      TablerIconsModule.pick(TablerIcons)
    ),
    provideToastr({
      timeOut: 2000,
      positionClass: "toast-top-center",
      progressBar: true,
    }),
  ],
};
